import { useMemo } from "react";
import { useAppSelector } from "@store";

export const DIMENSION_C = "dimensions-C";
export const useIsCompositeProject = () => {
  const { currentProject } = useAppSelector((state) => state.project);
  const isCompositeProject = useMemo(()=>{
    if(!currentProject)
        return false;
    const { dataSource : { name: dataSourceName }= {}} = currentProject;
    return dataSourceName === DIMENSION_C;
  }, [currentProject])
   
  return {
    isCompositeProject
  };
};
